export default "__VITE_PUBLIC_ASSET__583c84fb__"